import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGenerateTitleAudioBatchBody } from './generate-title-audio-batch-request';
import type { IGenerateTitleAudioBatchResponse } from './generate-title-audio-batch-response';
import { generateTitleAudioBatchResponseSchema } from './generate-title-audio-batch-response';

export async function generateTitleAudioBatchApi(
  body: IGenerateTitleAudioBatchBody,
): Promise<IValidatedResponse<IGenerateTitleAudioBatchResponse>> {
  return postRequest<IGenerateTitleAudioBatchResponse>({
    path: '/sys/challenges/audio/title-batch',
    body,
    schema: generateTitleAudioBatchResponseSchema,
  });
}
